'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSendFromResponders = undefined;

var _reselect = require('reselect');

var _buildSendFromResponders = require('conversations-schema/operators/widget-data/buildSendFromResponders');

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

var getSendFromResponders = exports.getSendFromResponders = (0, _reselect.createSelector)([_getLatestWidgetData.getLatestWidgetData], _buildSendFromResponders.buildSendFromResponders);